import classNames from "classnames";
import React from "react";

interface IProps {
  title?: string;
  children: React.ReactNode;
  onClick?: () => void;
  className?: string | classNames.ArgumentArray;
}

function GreyBox({ title, children, onClick, className }: IProps) {
  return (
    <div
      className={classNames("flex flex-col rounded-2.5 bg-tuneGrey-100 px-5 py-5", className)}
      onClick={() => {
        onClick?.();
      }}
      role="presentation"
    >
      {Boolean(title) && <div className="mb-5 font-normal">{title}</div>}
      {children}
    </div>
  );
}

export default GreyBox;
